export const USER_FLOW_REQUEST = "USER_FLOW_REQUEST";
export const USER_FLOW_SUCCESS = "USER_FLOW_SUCCESS";
export const USER_FLOW_ERROR = "USER_FLOW_ERROR";
